module.exports = __webpack_public_path__ + "static/media/vice-president.f63a5e01.jpg";